import React, { FC, useContext, useMemo } from 'react';
import { PageHeader } from '../components/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';
import { OrganizationAllLicensesFetcher } from '../fetchers/OrganizationAllLicensesFetcher';
import { OrganizationAllLicensesContextFromFetcher } from '../contexts/LicensesContextProviders';
import { AllLicensesTable } from '../components/AllLicensesTable/AllLicensesTable';
import Grid from '@mui/material/Grid';
import { EasyFilter } from '../components/EasyFilter/EasyFilter';
import { OrganizationAllLicensesContext } from '../contexts/OrganizationAllLicensesContext';
import { IQuickFiltersProps } from '../components/EasyFilter/QuickFilters';
import { FilteringContextProvider } from '../contexts/FilteringContext';

const AllLicensesFilter: FC = () => {
  const { t } = useTranslation();
  const { licenses } = useContext(OrganizationAllLicensesContext);

  const quickFilters = useMemo<IQuickFiltersProps['quickFilters']>(() => {
    const filters = new Map();

    const modes = (licenses ?? []).map((l) => l.mode);
    const hasUnassigned = modes.includes('unassigned');
    const hasUnused = modes.includes('unused');

    if (hasUnassigned) {
      filters.set(t('common.licenseMode.unassigned'), {
        filterField: 'mode',
        filterOp: 'equals',
        filterVal: 'unassigned',
        isVisible: true,
      });
    }
    if (hasUnused) {
      filters.set(t('common.licenseMode.notInUse'), {
        filterField: 'mode',
        filterOp: 'equals',
        filterVal: 'unused',
        isVisible: true,
      });
    }

    return filters;
  }, [licenses, t]);

  return <EasyFilter quickFilters={quickFilters} />;
};

export const AllLicensesPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PageHeader title={t('layout.navigation.allLicenses')} />
      <FilteringContextProvider>
        <OrganizationAllLicensesFetcher.WAF>
          <OrganizationAllLicensesContextFromFetcher hideDiscovery={true}>
            <Grid container>
              <Grid item xs={12} md={8}>
                <AllLicensesFilter />
              </Grid>
              <Grid item xs={12} md={4} display="flex" justifyContent="right" alignItems="center" />
            </Grid>

            <AllLicensesTable />
          </OrganizationAllLicensesContextFromFetcher>
        </OrganizationAllLicensesFetcher.WAF>
      </FilteringContextProvider>
    </div>
  );
};
